<div [ngStyle]="{visibility: getVisible()}" class="toolbar">
  <app-toolbar></app-toolbar>
</div>

<div class="data">

  <div [hidden]='getVisible() == "hidden"' [ngStyle]="{visibility: getVisible()}" class="menu">
    <app-menu></app-menu>
  </div>

  <div [ngStyle]="{height: getHeight(), width: getWidth(), margin: getMargin(), position: 'relative'}" class="content">
    <router-outlet></router-outlet>
  </div>

  <div [hidden]='getVisible() == "hidden"' [ngStyle]="{visibility: getVisible()}" class="info">
    <app-info></app-info>
  </div>
</div>
